import { createSelector } from 'reselect';
import { listToMap, populateFromMap } from '../transform';

const getTags = state => state.tags.data;
const getGroups = state => state.groups.list;
const getCategories = state => state.categories.list;
const getLocations = state => state.locations.list;

/**
  @name getPopulatedTags
  Selector to obtain the populated tags with zone/location/category/group info
*/
const getPopulatedTags = createSelector(
  [getTags, getLocations, getCategories, getGroups],
  (tags, locationsFromState, categoriesFromState, groupsFromState) => {
    let locationsMap = listToMap(locationsFromState, 'macAddress');
    let categoriesMap = listToMap(categoriesFromState);
    let groupsMap = listToMap(groupsFromState);

    let tagList = populateFromMap(
      tags,
      'location',
      locationsMap,
      'macAddress'
    );
    tagList = populateFromMap(tagList, 'category', categoriesMap);
    tagList = populateFromMap(tagList, 'group', groupsMap);
    return tagList;
  }
);

export default getPopulatedTags;



// WEBPACK FOOTER //
// ./src/utils/selectors/getPopulatedTags.js